module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_9005.87136ca3.png";